<template>
  <svg
    id="tt-logo-fi"
    data-name="tt-logo-fi"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 330 130"
  >
    <path
      class="cls-1"
      d="M44.62,15.81H29.83V63.87H20.07V15.81H5.2V6.05H44.62Z"
    />
    <path
      class="cls-1"
      d="M89.31,63.87H53.26V6.05H89.31v9.76H63V30.08H86.3v9.76H63V54.11H89.31Z"
    />
    <path
      class="cls-1"
      d="M137.74,63.87H126.48l-12-24h-7v24H97.72V6.05h22.75A16.56,16.56,0,0,1,127,7.36,17.16,17.16,0,0,1,132.41,11a16.92,16.92,0,0,1,3.64,5.4A16.44,16.44,0,0,1,137.37,23a16.8,16.8,0,0,1-.91,5.48,16.59,16.59,0,0,1-2.55,4.77A17.41,17.41,0,0,1,130,36.91a16.27,16.27,0,0,1-5.07,2.33ZM127.6,23a6.79,6.79,0,0,0-.56-2.74,7.27,7.27,0,0,0-1.54-2.29,7.1,7.1,0,0,0-2.29-1.54,6.83,6.83,0,0,0-2.74-.57h-13V30.08h13a7,7,0,0,0,2.74-.56A7.27,7.27,0,0,0,125.5,28,7.44,7.44,0,0,0,127,25.73,6.77,6.77,0,0,0,127.6,23Z"
    />
    <path
      class="cls-1"
      d="M192.56,6.05,166.28,66.13,140,6.05h10.67L166.28,41.8,181.9,6.05Z"
    />
    <path
      class="cls-1"
      d="M236.11,63.87h-36V6.05h36v9.76H209.83V30.08h23.28v9.76H209.83V54.11h26.28Z"
    />
    <path
      class="cls-1"
      d="M280.57,63.87h-36V6.05h36v9.76H254.29V30.08h23.28v9.76H254.29V54.11h26.28Z"
    />
    <path
      class="cls-1"
      d="M324.8,15.81H310V63.87h-9.77V15.81H285.38V6.05H324.8Z"
    />
    <path
      class="cls-1"
      d="M44.62,75.89H29.83V124H20.07V75.89H5.2V66.13H44.62Z"
    />
    <path class="cls-1" d="M63,124H53.26V66.13H63Z" />
    <path class="cls-1" d="M111.08,124H75V66.13H84.8v48.06h26.28Z" />
    <path
      class="cls-1"
      d="M164,124H153.36l-4.28-9.76H126.4L122.12,124H111.46l26.28-60.08ZM144.8,104.42,137.74,88.2l-7.06,16.22Z"
    />
    <path
      class="cls-1"
      d="M197.74,75.89H183V124h-9.76V75.89H158.32V66.13h39.42Z"
    />
    <path
      class="cls-1"
      d="M215.34,111.82A17.81,17.81,0,0,0,215,114h-.29c.67-8.06,6.5-11.4,11.48-14.65,4-2.62,7.47-6.2,7.47-10.85,0-2.19-1-4-3.25-4a4.56,4.56,0,0,0-4.81,4.6,2.64,2.64,0,0,0,1.18,2.37,4.76,4.76,0,0,1-4.68,4,3.45,3.45,0,0,1-3.55-3.76c0-6.54,8.32-7.6,11.95-7.6,7.89,0,11.44,2.28,11.44,6.38,0,6.2-6.12,8.74-12,10.17-4.18,1-8.53,1.82-11.61,5.24a7.39,7.39,0,0,1,5.27-2c4,0,7.9,2.58,12.25,2.58,1.85,0,3.71-.47,4.47-2.49l.25,0c-1.56,4.94-3.8,10.26-9.24,10.26C226.86,114.31,217,109.45,215.34,111.82Z"
    />
    <path
      class="cls-1"
      d="M271.71,96.32c0,8.61-6.2,18-16.38,18-7.39,0-11.57-5.07-11.57-12.12,0-8.65,6.13-18,16.34-18C267.49,84.16,271.71,89.27,271.71,96.32Zm-8.65-5.74c0-4.14-1-6.08-3-6.08-4.9,0-7.68,15.88-7.68,23.47,0,4.1,1,6,3,6C260.27,114,263.06,98.22,263.06,90.58Z"
    />
    <path
      class="cls-1"
      d="M272.21,111.82a17.86,17.86,0,0,0-.29,2.19h-.3c.68-8.06,6.5-11.4,11.48-14.65,4-2.62,7.48-6.2,7.48-10.85,0-2.19-1-4-3.25-4a4.56,4.56,0,0,0-4.82,4.6,2.64,2.64,0,0,0,1.18,2.37,4.75,4.75,0,0,1-4.68,4,3.45,3.45,0,0,1-3.55-3.76c0-6.54,8.32-7.6,12-7.6,7.89,0,11.44,2.28,11.44,6.38,0,6.2-6.12,8.74-12,10.17-4.18,1-8.53,1.82-11.61,5.24a7.4,7.4,0,0,1,5.28-2c4,0,7.89,2.58,12.24,2.58,1.86,0,3.71-.47,4.47-2.49l.26,0c-1.57,4.94-3.8,10.26-9.25,10.26C283.74,114.31,273.9,109.45,272.21,111.82Z"
    />
    <path
      class="cls-1"
      d="M299.3,108.27c0-4.14,3.72-6.33,7.48-7.77C304.62,98.94,303,97,303,94.17c0-6.8,8-10,13.34-10,3.42,0,8.15,1.44,8.15,5.2,0,2.15-1.4,4.35-5.28,6.75,3,1.65,5.57,3.76,5.57,7.43,0,6.71-7.05,10.77-15.32,10.77C304.5,114.31,299.3,112.74,299.3,108.27Zm7.73-7.6c-2.53,1.56-4.9,4.22-4.9,7.22,0,3.42,3,6.08,7.73,6.08,4.22,0,8.06-1.94,8.06-5.07C317.92,105.23,311.42,103.71,307,100.67ZM319,96c2.15-2.06,3.25-4.26,3.25-6.29,0-2.82-2-5.15-5.7-5.15-3.55,0-6.42,1.86-6.42,4.69C310.11,92.48,314.88,93.79,319,96Z"
    />
  </svg>
</template>
<script>
export default {
  name: "componentGalleryLogo",
};
</script>
<style scoped>
#tt-logo-fi {
  width: 100px;
}
.cls-1 {
  fill: #fff;
}
</style>